import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import CompanyStatistics from "./sections/CompanyStatistics";
import MissionVisionValues from "./sections/MissionVisionValues";
import TeamLeadership from "./sections/TeamLeadership";
import CompanyHistoryTimeline from "./sections/CompanyHistoryTimeline";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <HeroBanner />
      <CompanyStatistics />
      <MissionVisionValues />
      <TeamLeadership />
      <CompanyHistoryTimeline />
      <Footer />
    </div>;
}